export default __webpack_public_path__ + "static/media/11.3.7ba3e4f9.jpg";